import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import Share from '@material-ui/icons/Share';

import { addBookmark, removeBookmark, isBookmark } from '../services/storageService'
import ItemCardDetails from '../components/ItemCardDetails'

const useStyles = makeStyles(theme => ({
    paper: {
        marginBottom: 20,
        padding: 10,
        minWidth: 240,
        boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.19)',
    },    
    divider: {
        margin: '5px 0',
    },
    card: {
        marginBottom: "10px",
    },
    starFull: {
        color: '#ff8500',
    },
    cardContent: {
        padding: "0 16px",
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
}));

export default function ItemCard({ item }) {
    const classes = useStyles();
    const [isFavourite, setIsFavourite] = useState(isBookmark(item))
    const [dialogOpen, setDialogOpen] = useState(false)
    const [detailsOpen, setDetailsOpen] = useState(false)

    const libraryState = useSelector(state => state.library)
    const quantity = item.quantidade
    const quantityDescription = quantity === 1 ? 'exemplar' : 'exemplares'

    const getItemLibraryDescription = item => {
        const library = libraryState.list.find(library =>
            library['id-biblioteca'] === item['id-biblioteca']
        )

        return library ? library.descricao : ''
    }

    const handleFavourite = item => {
        if(isFavourite) 
            removeBookmark(item)
        else    
            addBookmark(item)

        setIsFavourite(!isFavourite)
    }

    const shareItem = item => {
        if(navigator.share) {
            navigator.share({
                title: item.titulo,
                text: 'Veja este material no Bibliotecas UFRN:',
                url: window.location.href,
            })
        } else {
            let dummy = document.createElement("textarea")
            document.body.appendChild(dummy)
            dummy.value = window.location.href
            dummy.select()
            document.execCommand("copy")
            document.body.removeChild(dummy)
            setDialogOpen(true)
        }
    }

    const handleDetailsClick = () => {
        setDetailsOpen(!detailsOpen)
    };

    return (
        <Card className={classes.card}>
            <CardHeader
                title={item.titulo}
                subheader={
                    <>
                        {item.autor}
                        <Typography variant="subtitle2" color="textSecondary">{item['tipo-material']}</Typography>
                    </>

                }
            />
            
            {!!item['id-biblioteca'] && !!libraryState.list.length &&
                <CardContent className={classes.cardContent}>
                    <Typography variant="caption" color="textSecondary">
                        {quantity} {quantityDescription} em {getItemLibraryDescription(item)}
                    </Typography>
                </CardContent>
            }
            
            <CardActions disableSpacing>
                <IconButton 
                    aria-label="adicionar aos favoritos"
                    onClick={() => handleFavourite(item)}
                >
                    {isFavourite ?
                        <Star className={classes.starFull} /> :
                        <StarBorder/>
                    }
                </IconButton>
                
                <IconButton 
                    aria-label="compartilhar"
                    onClick={() => shareItem(item)}
                >
                    <Share />
                </IconButton>

                <IconButton
                    className={clsx(classes.expand, {
                        [classes.expandOpen]: detailsOpen,
                    })}
                    onClick={handleDetailsClick}
                    aria-label="show more">
                        <ExpandMore />
                </IconButton>
            </CardActions>

            <ItemCardDetails item={item} open={detailsOpen} />

            <Dialog aria-labelledby="simple-dialog-title" open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle id="simple-dialog-title">Compartilhamento</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        O link foi copiado para a área de transferência.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)} color="primary" autoFocus>
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>
    );
}